import { render, staticRenderFns } from "./ActividadTabla.html?vue&type=template&id=2d096d94&external"
import script from "./ActividadTabla.vue?vue&type=script&lang=js"
export * from "./ActividadTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports